import { HOOFDPARTNER } from "../data/site";

export default function Hoofdpartner({ showLabel = true, compact = false }) {
  if (!HOOFDPARTNER?.logo) return null;
  const cardSize = compact
    ? "max-w-sm px-5 py-6"
    : "max-w-md px-6 py-7";
  const logoSize = compact
    ? "max-h-12 sm:max-h-16"
    : "max-h-16 sm:max-h-20";
  return (
    <div data-testid="hoofdpartner-card" className="flex justify-center">
      <a
        href={HOOFDPARTNER.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="hoofdpartner-link"
        title={HOOFDPARTNER.name}
        className={`group relative w-full ${cardSize} bg-white rounded-2xl border border-[#ebd9b5] shadow-[0_14px_36px_-18px_rgba(43,28,16,0.22)] flex flex-col items-center transition-transform duration-300 hover:-translate-y-0.5`}
      >
        {showLabel && (
          <span className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-[0.14em] bg-orange-gradient text-white shadow-md">
            {HOOFDPARTNER.role}
          </span>
        )}
        <img
          src={HOOFDPARTNER.logo}
          alt={HOOFDPARTNER.name}
          className={`${showLabel ? "mt-5" : ""} ${logoSize} w-auto object-contain`}
          loading="lazy"
        />
      </a>
    </div>
  );
}
